import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Row, Col, Spin, Table, Select } from 'antd'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper'
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector'
import WidgetCustomerSelector from 'src/widgets/Selectors/WidgetCustomerSelector'
import { wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils'
import WidgetFiscalYearSelector from 'src/widgets/Selectors/WidgetFiscalYearSelector'
import './style.css'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { SALE_ORDER_INVOICES_DATE_NAMES, SALE_ORDER_INVOICES_DATE_TYPE_DROPDOWN_OPTIONS, SALE_ORDER_INVOICES_FBR_STATUS_DROPDOWN_OPTIONS, FBR_STATUS_NAMES, SALE_ORDER_INVOICES_STATUS_DROPDOWN_OPTIONS, SALE_ORDER_INVOICES_STATUS_NAME } from 'src/models/sale-order-invoice'
import { DEPARTMENT_TYPE_ADD_SALE_ORDER, DEPARTMENT_TYPE_VIEW_SALE_ORDER } from 'src/models/department-permission'
import WidgetDepartmentSelector from 'src/widgets/Selectors/WidgetDepartmentSelector'

const SaleSummaryReport = () => {
  const Base = new BaseListing('sale_summary_report')
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const [branchId, setBranchId] = useState(0)
  const [branchName, setBranchName] = useState('')
  const branches = wtGetFromLocalStorage('branches')
  const [customers, setCustomers] = useState([])
  const [projects, setProjects] = useState([])
  const [ProjectId, setProjectId] = useState(null)
  const [ProjectName, setProjectName] = useState('')
  const [fiscalYearId, setFiscalYearId] = useState(0)
  const [fiscalYearName, setFiscalYearName] = useState('')
  const [fiscalYears, setFiscalYears] = useState([])
  const [PartyName, setPartyName] = useState('')
  const [PartyId, setPartyId] = useState(null)
  const [statusId, setStatusId] = useState(0)
  const [dateType, setDateType] = useState(0)
  const [fbrStatus, setFbrStatus] = useState(null)
  const [searchMore, setSearchMore] = useState(false)
  const [saleSummaryReportData, setSaleSummaryReportData] = useState([])

  const [departments, setDepartments] = useState([])
  const [departmentId, setDepartmentId] = useState(null)
  const [departmentName, setDepartmentName] = useState('')

  const changeValues = (key, val) => {
    setSaleSummaryReportData([])
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)

      // reset department
      setDepartmentId(null)
      setDepartmentName('')
      setDepartments([])

      // fetch departments based on branch
      if (val?.value) {
        Base.dropdownData(
          'user_departments',
          { __branch_id: val.value, type: DEPARTMENT_TYPE_VIEW_SALE_ORDER },
          [setDepartments],
          1
        )
      }
    }

    if (key === 'department_id') {

      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }

    if (key === 'fiscal_year_id') {
      setFiscalYearId(val.value)
      setFiscalYearName(val.label)
    }
    if (key === 'project_id') {
      setProjectId(val)
      const selectedProject = projects.find((p) => p.value === val)
      setProjectName(selectedProject ? selectedProject.title : '')
    }
    if (key === 'customer_id') {
      setPartyId(val)
      if (val === null) {
        setPartyName('')
      }
    }
    if (key === 'status') {
      if (val === null) {
        setStatusId(0)
      }
      setStatusId(val?.value)
    }
    if (key === 'date_type') {
      if (val === null) {
        setDateType(0)
      }
      setDateType(val?.value)
    }

    if (key === 'fbr_status') {
      if (key === 'fbr_status') {
        setFbrStatus(val ?? null)
      }
    }


  }

  const exportToExcel = () => {
    console.log(saleSummaryReportData)
    setIsLoading(true)
    wtApiPostWithContentTypeHandling('sale_summary_report/export', { data: saleSummaryReportData })
    setIsLoading(false)
  }

  useEffect(() => {
    Base.dropdownData(
      'customers,projects,fiscal_years',
      {},
      [setCustomers, setProjects, setFiscalYears],
      1,
    )
  }, [])

  const getReportData = () => {

    setIsLoading(true)
    wtApiCall(
      'reports/sale_summary_report',
      {
        branch_id: branchId,
        fiscal_year_id: fiscalYearId,
        party_id: PartyId,
        project_id: ProjectId,
        status: statusId,
        date_type: dateType,
        fbr_status: fbrStatus,
        department_id: departmentId,

      },
      'get',
      (response) => {
        setSaleSummaryReportData(response.data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }


  const columns = [
    {
      title: 'Month',
      dataIndex: 'month',
      key: 'month',
      ellipsis: true,
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {record.month}
        </span>
      ),
    },
    {
      title: 'Sale',
      dataIndex: 'sale',
      key: 'sale',
      width: "8%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.sale, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Discount',
      dataIndex: 'discount',
      key: 'discount',
      width: "6%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.discount, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Sales less discount',
      dataIndex: 'sale_less_discount',
      key: 'sale_less_discount',
      width: "11%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.sale_less_discount, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Sales tax',
      dataIndex: 'sales_tax',
      key: 'sales_tax',
      width: "8%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.sales_tax, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Further Tax',
      dataIndex: 'further_tax',
      key: 'further_tax',
      width: "8%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.further_tax, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Total Tax',
      dataIndex: 'total_tax',
      key: 'total_tax',
      width: "8%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.total_tax, "", false, 2)}
        </span>
      ),
    },
    {
      title: 'Sales Inclusive All Taxes',
      dataIndex: 'sales_inclusive_all_taxes',
      key: 'sales_inclusive_all_taxes',
      width: "13%",
      ellipsis: true,
      align: "right",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.month === 'Total' ? 'bold' : 'normal'
          }}
        >
          {wtFormatRoundedValue(record.sales_inclusive_all_taxes, "", false, 2)}
        </span>
      ),
    }
  ]

  return (
    <div
      className="container-fluid"
      style={{
        padding: '1em',
        backgroundColor: 'white',
        minHeight: '100vh',
        fontFamily: 'Helvetica',
      }}
    >
      <Form
        layout={'vertical'}
        form={form}
        onFinish={getReportData}
        style={{ maxWidth: '100%', margin: '0 auto' }}
      >
        <Card
          style={{ width: '100%' }}
          title={
            <span style={{ fontSize: '26px', marginLeft: '40%' }}>
              Sale Summary Report
            </span>
          }
        >
          <Row gutter={[24, 24]}>
            <Col xs={15} sm={10} md={4}>
              <label>Fiscal Year:</label>
              <WidgetFiscalYearSelector
                size='md'
                value={fiscalYearId}
                displayValue={fiscalYearName}
                fiscalYears={fiscalYears}
                onChange={(values) => changeValues('fiscal_year_id', values)}
                reloadDropdownData={(values) => Base.dropdownData('fiscal_years', {}, [setFiscalYears], 1)}
                showCloudIcon={true}
              />
            </Col>

            <Col xs={15} sm={10} md={4}>
              <label>Status:</label>
              <WidgetSelector
                options={SALE_ORDER_INVOICES_STATUS_DROPDOWN_OPTIONS}
                selectedValue={statusId}
                displayValue={SALE_ORDER_INVOICES_STATUS_NAME[statusId]}
                onChange={(values) => changeValues("status", values)}
              />
            </Col>

            <Col xs={15} sm={10} md={4}>
              <label>Date Type:</label>
              <WidgetSelector
                options={SALE_ORDER_INVOICES_DATE_TYPE_DROPDOWN_OPTIONS}
                selectedValue={dateType}
                displayValue={SALE_ORDER_INVOICES_DATE_NAMES[dateType]}
                onChange={(values) => changeValues("date_type", values)}
              />
            </Col>

            <Col xs={15} sm={10} md={4}>
              <label>Branch:</label>
              <WidgetBranchSelector
                value={branchId}
                displayValue={branchName}
                branches={branches}
                placeholder="Select Branch"
                onChange={(values) => changeValues('branch_id', values)}
                showCloudIcon={false}
              />
            </Col>

            <Col xs={15} sm={10} md={5}>
              <Button
                style={{ marginTop: 30, marginRight: 5 }}
                type="primary"
                htmlType="submit"
                disabled={isLoading ? true : false}
              >
                Search
              </Button>
              <Button
                style={{ marginTop: 30, marginRight: 5, backgroundColor: '#4BB543', color: '#fff' }}
                onClick={exportToExcel}
                disabled={isLoading ? true : false}
              >
                Export
              </Button>
              <Button style={{ marginTop: 30, marginRight: 5, color: "#fff", backgroundColor: "#E29C06" }} onClick={() => setSearchMore(!searchMore)} disabled={isLoading ? true : false}>{searchMore ? "Less..." : "More..."}</Button>

            </Col>
          </Row>

          {searchMore && (
            <Row gutter={[24, 24]}>

              <Col xs={15} sm={10} md={5}>
                <label>Customer</label>
                <WidgetCustomerSelector
                  onChange={(value) => changeValues('customer_id', value)}
                  customers={customers}
                  displayValue={PartyName}
                  value={PartyId}
                  reloadDropdownData={() => reloadParties()}
                />
              </Col>
              <Col xs={15} sm={10} md={5}>
                <label>Project:</label>
                <WidgetProjectSelector
                  onChange={(value) => changeValues('project_id', value)}
                  data={projects} // <-- Use the formatted treeData here
                  value={ProjectId}
                  displayValue={ProjectName}
                  height={35}
                  reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                />
              </Col>

              <Col xs={15} sm={10} md={4}>
                <label>FBR Status:</label>
                <Select
                  placeholder="Select FBR Status"
                  allowClear
                  value={fbrStatus}
                  style={{ width: '100%' }}
                  options={SALE_ORDER_INVOICES_FBR_STATUS_DROPDOWN_OPTIONS}
                  onChange={(values) => changeValues("fbr_status", values)}
                />
              </Col>

              <Col xs={15} sm={10} md={5}>
                <label>Department:</label>
                <WidgetDepartmentSelector
                  value={departmentId}
                  departments={departments}
                  onChange={(values) => changeValues('department_id', values)}
                  displayValue={departmentName}
                  reloadDropdownData={() =>
                    Base.dropdownData(
                      'departments',
                      { __branch_id: branchId, type: DEPARTMENT_TYPE_VIEW_SALE_ORDER },
                      [setDepartments],
                      1,
                    )
                  }
                />
              </Col>

            </Row>
          )}
        </Card>
      </Form>


      <Card style={{ margin: 'auto', width: "80%" }}>
        <Spin spinning={isLoading}>
          <Table
            className="sale-summary-table"
            columns={columns}
            dataSource={saleSummaryReportData}
            pagination={false}
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 400 }}
            loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
            style={{ cursor: "pointer" }}
            onRow={(record) => ({
              onClick: () => {
                const params = new URLSearchParams({
                  date: record.month,
                  status: statusId,
                  date_type: dateType,
                  branch_id: branchId,
                  branch_name: branchName,
                  party_id: PartyId,
                  party_name: PartyName,
                  project_id: ProjectId,
                  project_name: ProjectName,
                  fbr_status: fbrStatus,
                  department_id: departmentId,
                  department_name: departmentName,
                });

                window.open(`/reports?${params.toString()}#code:sale-book-report`, '_blank');
              },
            })}
          />
        </Spin>
      </Card>
    </div>
  )
}
export default SaleSummaryReport
